import "./Modal.css";

export default function Modal({ title, users, onClose }) {
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button className="close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="modal-body">
                    {users.length === 0 ? (
                        <div className="empty-state">
                            No users found
                        </div>
                    ) : (
                        users.map((user) => (
                            <div key={user.id} className="user-item">
                                <div className="avatar">
                                    {user.name.charAt(0).toUpperCase()}
                                </div>
                                <span>{user.name}</span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
